(() => {
  const showTraining = $(".widget-academy__click-here");
  const showNewsletter = $(".widget-newsletter__click-here");

  if (showTraining.length) {
    const trainingModal = $(".article-sidebar-mobile .widget-academy");
    const closeTraining = $(".widget-academy__close-modal");

    showTraining.on("click", () => {
      trainingModal.show();
    });

    closeTraining.on("click", () => {
      trainingModal.hide();
    });
  }

  if (showNewsletter.length) {
    const newsletterModal = $(".article-sidebar-mobile .widget-newsletter");
    const closeNewsletter = $(".widget-newsletter__close-modal");

    showNewsletter.on("click", () => {
      newsletterModal.show();
    });

    closeNewsletter.on("click", () => {
      newsletterModal.hide();
    });
  }
})();
